import { render, staticRenderFns } from "./Demo2.vue?vue&type=template&id=346fcc46"
import script from "./Demo2.vue?vue&type=script&lang=js"
export * from "./Demo2.vue?vue&type=script&lang=js"
import style0 from "./Demo2.vue?vue&type=style&index=0&id=346fcc46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports